import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { StoreForm } from '@/components/forms/StoreForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function EditStorePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const storeId = id ? Number(id) : undefined

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Edit Store</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Update store details using Business Unit (Client) as the context
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <StoreForm
              storeId={storeId}
              onSuccess={() => navigate('/organization/stores')}
              onCancel={() => navigate('/organization/stores')}
            />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
